import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

const Terms = () => {
  const lastUpdated = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      {/* Main Content */}
      <main className="flex-1 py-16 md:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-manrope font-bold text-3xl md:text-4xl text-foreground mb-2">
            Terms of Service
          </h1>
          <p className="text-muted-foreground mb-2">Relocation Clarity</p>
          <p className="text-sm text-muted-foreground mb-10">Last updated: {lastUpdated}</p>

          <div className="space-y-8 text-foreground">
            {/* Section 1 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">1. What This Service Is</h2>
              <p className="leading-relaxed mb-3">
                Relocation Clarity provides planning guidance and decision-support tools for individuals exploring the possibility of living abroad.
              </p>
              <p className="leading-relaxed mb-3">
                We offer a free assessment experience and an optional, low-cost personalized Relocation Blueprint.
              </p>
              <p className="leading-relaxed">
                We do not provide legal, immigration, tax, financial, or real estate advice.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">2. What This Service Is Not</h2>
              <p className="leading-relaxed mb-3">Relocation Clarity does not:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Guarantee visa approval, residency, or relocation outcomes</li>
                <li>Replace licensed professionals such as immigration attorneys, tax advisors, or financial planners</li>
                <li>Make decisions on your behalf</li>
              </ul>
              <p className="leading-relaxed mt-3">All decisions remain your responsibility.</p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">3. User Responsibilities</h2>
              <p className="leading-relaxed mb-3">By using this service, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Provide accurate and honest information</li>
                <li>Use the guidance as informational input only</li>
                <li>Independently verify important details before making commitments</li>
                <li>Consult qualified professionals when appropriate</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">4. Payments & Refunds</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Payments are processed securely by Stripe</li>
                <li>We do not store or process credit card information</li>
                <li>Refund policies are disclosed at the time of purchase</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">5. Intellectual Property</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>You retain ownership of the information you submit</li>
                <li>All site content, branding, and materials belong to Relocation Clarity</li>
                <li>You may not copy, redistribute, or resell site content without permission</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">6. Limitation of Liability</h2>
              <p className="leading-relaxed mb-3">This service is provided "as is."</p>
              <p className="leading-relaxed mb-3">Relocation Clarity is not liable for:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Decisions made based on the guidance</li>
                <li>Financial loss, visa outcomes, or relocation results</li>
                <li>Errors, omissions, or changes in third-party rules or regulations</li>
              </ul>
              <p className="leading-relaxed mt-3">Liability is limited to the amount paid for the service.</p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">7. Service Availability</h2>
              <p className="leading-relaxed">
                We do not guarantee uninterrupted access, error-free operation, or continued availability of specific features.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">8. Termination</h2>
              <p className="leading-relaxed mb-2">We may suspend or terminate access if the service is misused.</p>
              <p className="leading-relaxed">You may stop using the service at any time.</p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">9. Changes to These Terms</h2>
              <p className="leading-relaxed">
                We may update these Terms periodically. Continued use indicates acceptance.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">10. Contact</h2>
              <p className="leading-relaxed">
                Questions? Contact us using the{" "}
                <Link to="/contact" className="text-primary hover:underline">
                  contact form
                </Link>
                .
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
